import React, { useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { NodeTextField } from '../../NodeUI';
import './CoverImageEditor.css';

export default function CoverImageEditor({ value, onChange, className = '' }) {
  const handleClear = useCallback(() => {
    onChange('');
  }, [onChange]);

  return (
    <div className={`cover-image-editor${className ? ` ${className}` : ''}`}>
      <div className="cover-image-editor__input-wrap">
        <NodeTextField
          label="Cover image URL"
          value={value || ''}
          onChange={onChange}
          placeholder="https://example.com/image.jpg"
        />
        {value ? (
          <button
            type="button"
            className="cover-image-editor__clear"
            onClick={handleClear}
            aria-label="Clear cover image"
          >
            <CloseIcon />
          </button>
        ) : null}
      </div>
      <p className="cover-image-editor__hint">
        Shown at the top of the public form. Leave empty for an auto-generated gradient unique to this form.
      </p>
    </div>
  );
}
